import React from 'react';
import {
  SitemapCollection as SitemapCollectionType,
  SitemapItems,
} from '../../../../types';
import SitemapItem from '../sitemap-item';
import * as S from './styles';

type Props = Pick<SitemapCollectionType, 'sitemapItems'>;

const SitemapCollection = ({ sitemapItems }: Props) => {
  return (
    <S.SitemapItemList>
      {Array.isArray(sitemapItems) &&
        sitemapItems
          .filter((obj): obj is SitemapItems => obj !== undefined)
          .map(({ path, title }) => (
            <SitemapItem key={path} path={path} title={title} />
          ))}
    </S.SitemapItemList>
  );
};

export default SitemapCollection;
